module.exports = {"id":"201042","name":"Djibril Sidibé","rating":"78","photo":"./data/images/photos/4/201042.png","club":{"name":"AS Monaco","logo":"./data/images/clubs/ASMonaco.png"},"positions":["DD","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DjibrilSidibe0.json
// module id = 1118
// module chunks = 0